import { inject, Injectable } from '@angular/core';
import { StoreManager } from '../../app-state/store.manager';
import { UserStore } from '../../app-state/user.store';

/**
 * The one place authentication state is torn down, shared by explicit logout
 * and session expiry so both follow the same lifecycle: every store is reset
 * (cancelling in-flight loads), so the next login starts clean and refetches
 * per-user data such as the effective customization, even for the same user.
 * Storage clearing and navigation stay with each caller; they differ by path.
 */
@Injectable({ providedIn: 'root' })
export class AuthTeardownService {
  private readonly storeManager = inject(StoreManager);
  private readonly userStore = inject(UserStore);

  /**
   * @param options.isAuthError true when authentication failed or expired
   *   (rather than the user logging out); the auth guard reads this flag.
   */
  clearAuthentication(options: { isAuthError?: boolean } = {}): void {
    this.storeManager.resetAllStores();
    if (options.isAuthError) {
      this.userStore.setUser({
        user: null,
        organizationUser: null,
        organization: null,
        token: null,
        isLoading: false,
        error: true,
        role: null,
        authApp2FAenabled: null,
        email2FAEnabled: null,
      });
    }
  }
}
